import React from 'react';
import './ImageShimmer.css';

const ImageShimmer = ({ width = '100%', height = '100%', className = '' }) => {
  return (
    <div 
      className={`image-shimmer ${className}`}
      style={{ width, height }}
    >
      <div className="shimmer-content"></div>
    </div>
  );
};

export default ImageShimmer;
